<template>
	<div class="wrapper" id="test-vue">
		<menuAdmin />
		<!-- Page Content Holder -->
		<div id="content" class="col-xs-12">
			<router-view> </router-view>

			<div id="fiche-modal"></div>
			<div id="highlight-modal"></div>
			<div id="mediacontent-modal"></div>
		</div>
		<Footer />
	</div>
</template>
<script>
import menuAdmin from "@/components/globalVue/menuAdmin.vue";
import Footer from "@/components/globalVue/Footer.vue";
export default {
	name: "Base",
	components: {
		menuAdmin,
		Footer,
	},
	created: function () {
		this.$store.dispatch("removeFromParameters", "mastertag");
		this.$store.dispatch("removeFromParameters", "subcategory");
		this.$store.dispatch("removeFromParameters", "category");
		this.$store.dispatch("removeFromParameters", "page");
		this.$store.dispatch("removeFromParameters", "date_created");
		this.$store.dispatch("removeFromParameters", "supervision_panel");
		this.$store.dispatch("removeFromParameters", "panel");
		this.$store.dispatch("removeFromParameters", "range");
		this.$store.dispatch("removeFromParameters", "period");
		this.$store.dispatch("removeFromParameters", "contentClass");
		this.$store.dispatch("removeFromParameters", "click");
		this.$store.dispatch("removeFromParameters", "searchallwords");
		this.$store.dispatch("removeFromParameters", "mastertagEvent");
		this.$store.dispatch("removeFromParameters", "mastertagEventWC");
		this.$store.dispatch("removeFromParameters", "tagclassWC");
		//this.$store.dispatch("setMastertagTop100", "");
		this.$store.dispatch("removeFromParameters", "expired_filters");

		if (this.$store.getters.expiredFilters !== "" && this.$moment().isAfter(this.$store.getters.expiredFilters)) {
			this.$store.dispatch("removeFromParameters", "gender");
			this.$store.dispatch("removeFromParameters", "age");
			this.$store.dispatch("removeFromParameters", "country");
			this.$store.dispatch("removeFromParameters", "sources");
			this.$store.dispatch("setExpiredFilters", "");
			//console.log(this.$store.getters.expiredFilters);
		}

		this.$axios.get(this.$backendUrl + "getSessionInfos").then((response) => {
			let params = this.$store.getters.parameters ? this.$store.getters.parameters : {};
			params.type = params.type ? params.type : "Posts";

			this.$store.dispatch("setPanel", response.data.panel);
			this.$store.dispatch("setSegment", response.data.segment);
			this.$store.dispatch("setPageName", response.data.pageName);
			this.$store.dispatch("setAdmin", response.data.admin);
			this.$store.dispatch("setUserId", response.data.userId);

			let dateToday = new Date();
			dateToday = dateToday.toISOString().split("T")[0];
			let oneYearFromNow = new Date();
			oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() - 1);
			oneYearFromNow = oneYearFromNow.toISOString().split("T")[0];
			params.date = params.date ? params.date : { gte: oneYearFromNow, lte: dateToday };
			if (response.data.pageName === "subscribe") {
				params.date = { gte: oneYearFromNow, lte: dateToday };
			}

			if (response.data.pageName === "brands") {
				params.tagclass = "brand";
			} else if (response.data.pageName === "topics") {
				params.tagclass = "tag";
			} else {
				delete params.tagclass;
			}
			this.$store.dispatch("setParameters", params);
		});
	},
};
</script>
<style></style>
